import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function(element) {
    gsap.from(element.querySelector(".image__banner .grass"), {
        scrollTrigger: {
            trigger: element,
            start: "top center",
            // toggleActions: "play none play none",
        },
        scale: 0.2,
        opacity: 0,
        duration: 2,
        ease: "power4.out",
    });
    gsap.from(element.querySelector(".image__banner .pills"), {
        scrollTrigger: {
            trigger: element,
            start: "top center",
        },
        scale: 0.4,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
    });
};